import React from 'react';
import { Link } from 'react-router-dom';
import {
  MenuItem,
  Paper,
  MenuList,
  ListItemIcon
} from '@material-ui/core';
import {
  Add,
  Remove,
  ExitToApp
} from '@material-ui/icons';
import { signOut } from './services';

const Home = () => {
  return <Paper style={{ width: '100%', maxWidth: 400 }}>
    <MenuList>
      <MenuItem style={{ paddingTop: 16, paddingBottom: 16 }} component={Link} to="/admin/board/register">
        <ListItemIcon>
          <Add />
        </ListItemIcon>
        Cadastrar BOARD
      </MenuItem>
      <MenuItem style={{ paddingTop: 16, paddingBottom: 16 }} component={Link} to="/admin/board/remove">
        <ListItemIcon>
          <Remove />
        </ListItemIcon>
        Remover BOARD
      </MenuItem>
      <MenuItem style={{ paddingTop: 16, paddingBottom: 16 }} onClick={signOut}>
        <ListItemIcon>
          <ExitToApp />
        </ListItemIcon>
        Sair
      </MenuItem>
    </MenuList>
  </Paper>
}

export default Home;